import { getLocale } from '../i18n';

export function formatDate(date: Date | string, options?: Intl.DateTimeFormatOptions): string {
  const d = typeof date === 'string' ? new Date(date) : date;
  const locale = getLocale();
  return new Intl.DateTimeFormat(locale, options).format(d);
}

export function formatNumber(value: number, options?: Intl.NumberFormatOptions): string {
  const locale = getLocale();
  return new Intl.NumberFormat(locale, options).format(value);
}

// Fixed conversion rates from BRL to target currencies.
// These can be replaced later with live rates from an API.
const BRL_TO_USD = 0.20; // Example fixed rate
const BRL_TO_CAD = 0.27; // Example fixed rate

export function formatCurrency(
  value: number,
  currency: string = 'BRL',
  options?: Intl.NumberFormatOptions
): string {
  const locale = getLocale();

  // Determine target display currency based on locale
  const localeLower = (locale || '').toLowerCase();
  const targetCurrency = localeLower.startsWith('en')
    ? 'USD'
    : localeLower.startsWith('fr')
      ? 'CAD'
      : 'BRL';

  // If caller explicitly requested a currency different from BRL, respect it without conversion
  if (currency && currency !== 'BRL') {
    return new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      ...options,
    }).format(value);
  }

  // Convert BRL to target currency when locale is en or fr
  let displayValue = value;
  let displayCurrency = targetCurrency;

  if (targetCurrency === 'USD') {
    displayValue = value * BRL_TO_USD;
  } else if (targetCurrency === 'CAD') {
    displayValue = value * BRL_TO_CAD;
  } else {
    // pt-BR or other locales default to BRL, no conversion
    displayCurrency = 'BRL';
    displayValue = value;
  }

  return new Intl.NumberFormat(locale, {
    style: 'currency',
    currency: displayCurrency,
    ...options,
  }).format(displayValue);
}

export function formatPercentage(value: number, fractionDigits: number = 1): string {
  return formatNumber(value * 100, { minimumFractionDigits: fractionDigits, maximumFractionDigits: fractionDigits }) + '%';
}